module.exports = __webpack_public_path__ + "img/ITA-logo.jpg.e003ef5a.webp";